import React, { useState } from "react";
import request from "../../utils/requests";
import securityToken from "../../utils/securityToken";
import styles from "./commentForm.module.scss";
import { AxiosError } from "axios";

interface ComponentTypes {
  postId: number;
}

interface FormInputTypes extends HTMLFormControlsCollection {
  comment: HTMLInputElement;
  author: HTMLInputElement;
  email: HTMLInputElement;
  city: HTMLInputElement;
}

interface FormTypes extends HTMLFormElement {
  readonly elements: FormInputTypes;
}

export const CommentForm = ({ postId }: ComponentTypes): JSX.Element => {
  const [formPopupMessage, setFormPopupMessage] = useState<string>("");

  const formHandle = async (e: React.FormEvent<FormTypes>) => {
    e.preventDefault();

    const cryptoKey = securityToken.encode({
      exp: securityToken.defaultExp(),
    });

    const { comment, author, email } = e.currentTarget.elements;

    const commentParams = {
      comment: comment.value,
      author: author.value,
      email: email.value,
      postId: String(postId),
      cryptoKey: cryptoKey,
    };

    const commentParamsQueryString = new URLSearchParams(commentParams);

    try {
      await request.get(`/api/comments/post/?${commentParamsQueryString}`);

      setFormPopupMessage(
        "Comentário enviado com sucesso. Ele será verificado e poderá aparecer na página em breve. Obrigado!"
      );
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error.request.status === 409) {
          setFormPopupMessage(
            "Você já comentou isso. Tente comentar algo diferente ou recarregar a página."
          );
        } else if (error.request.status === 403) {
          setFormPopupMessage(
            "Desculpe, mas seu comentário contém palavras não permitidas ou links. Reescreva para poder enviar."
          );
        } else {
          setFormPopupMessage(
            "Falha ao enviar comentário, tente novamente mais tarde."
          );
        }
      } else {
        setFormPopupMessage(
          "Falha ao enviar comentário, tente novamente mais tarde."
        );
      }
    }
  };

  return (
    <>
      <h3 className={styles.title}>Deixe um comentário</h3>
      <form
        role="form"
        id="commentform"
        className={styles.commentForm}
        onSubmit={formHandle}
      >
        <p>
          O seu endereço de e-mail não será publicado. Campos obrigatórios são
          marcados com *
        </p>

        <label htmlFor="comment">Comentário *</label>
        <textarea
          id="comment"
          name="comment"
          placeholder="Não envie links, senão bloquearemos o envio"
          rows={5}
          required
        ></textarea>

        <label htmlFor="author">Nome *</label>
        <input id="author" name="author" type="text" required />

        <label>E-mail *</label>
        <input
          id="email"
          name="email"
          type="email"
          aria-describedby="email-notes"
          required
        />

        <button
          name="submit"
          id="submit"
          type="submit"
          className={styles.submit}
        >
          Publicar comentário
        </button>

        {formPopupMessage !== "" && (
          <div className={styles.formError}>
            <p>{formPopupMessage}</p>
            <button
              name="submit"
              id="submit"
              type="submit"
              onClick={() => {
                setFormPopupMessage("");
              }}
            >
              Entendi
            </button>
          </div>
        )}
      </form>
    </>
  );
};
